export const getPhoneNumberWithoutPrefix = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.includes(' ') ? phoneNumber.split(' ')[1] : phoneNumber;
};

export const getAreaCode = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.includes(' ') ? phoneNumber.split(' ')[0].slice(1) : '';
};

// Strips invalid characters and limits digits after the decimal separator.
export const sanitizeAmount = (value: string, maxFractionDigits = 2): string => {
    const normalized = value.replace(/,/g, '.').replace(/[^\d.]/g, '');
    const firstDotIndex = normalized.indexOf('.');

    if (firstDotIndex === -1) return normalized;

    const integerPart = normalized.slice(0, firstDotIndex);
    const fractionPart = normalized.slice(firstDotIndex + 1).replace(/\./g, '');
    const fractionDigits = Math.max(0, Math.floor(maxFractionDigits));

    if (fractionDigits === 0) return integerPart;
    return `${integerPart}.${fractionPart.slice(0, fractionDigits)}`;
};
